<template>
  <button
    v-show="isScrolledPastThresholdHeight && !layoutStore.modalType"
    class="scroll-to-top-button"
    @click="scrollToTop()"
    type="button"
    title="Scroll to Top of Page"
  >
    <span class="arrow-angle"></span>
  </button>
</template>

<script lang="ts" setup>
  import { useLayoutStore } from '@/stores/layoutStore';
  import { useScrollToTop } from '@/composables/useScrollToTop';

  const layoutStore = useLayoutStore();
  const { scrollToTop, isScrolledPastThresholdHeight } = useScrollToTop();
</script>

<style scoped>
  button.scroll-to-top-button {
    all: unset;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    color: black;
    opacity: 0.5;
    text-align: center;
    line-height: 1;
    transition: opacity 0.5s ease 0s;
    border-radius: 50%;
    background-color: #555;
    width: 60px;
    height: 60px;
  }

  button.scroll-to-top-button:hover,
  button.scroll-to-top-button:active,
  button.scroll-to-top-button:focus {
    cursor: pointer;
    opacity: 1;
  }

  .arrow-angle {
    box-sizing: border-box;
    display: block;
    position: relative;
    left: 20px;
    top: 4px;
    width: 22px;
    height: 22px;
    border-right: 5px solid #fff;
    border-top: 5px solid #fff;
    transform: rotate(-45deg);
  }
</style>
